export enum MountImageStatus {
    DONE = "With Image",
    WITHOUT_IMAGE = "Without Image",
    PENDING = "Pending",
    PENDING_FLEX = "Pending Flex",
    PENDING_MOUNTING = "Pending Mounting",
    PENDING_UNMOUNTING = "Pending Unmounting",
    FLEX_RECEIVED = "Flex Received"

}